import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFlags } from '@fullstory/react-hooks';

export const useCompleteSessionsReplayFilters = (defaultValue: boolean = false) => {
  const history = useHistory();
  const flags = useFlags();

  const [completeSessionsOverride, setCompleteSessionsOverride] = useState(() => {
    const qpCompleteSessions = new URLSearchParams(history.location.search).get('completeSessions');
    return qpCompleteSessions === null ? defaultValue : qpCompleteSessions === 'true';
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);
    queryParams.delete('completeSessions');
    if (flags.featureFlags().AppCompleteSessionsConstraint) {
      queryParams.set('completeSessions', completeSessionsOverride.toString());
    }
    const queryString = `?${queryParams.toString()}`;
    if (queryString !== '?' && history.location.search !== queryString) {
      // NB: Generally, we use the useLocation hook to get the location.  useLocation works like a
      // useState that returns a new location whenever the URL changes.
      //
      // In certain circumstances, this useEffect was executing after the URL was updated but before
      // the location from useLocation was updated.  This caused the pathname to reset to a stale value.
      //
      // This useEffect should only modify the query string.  It should not modify any other part of the URL.
      // Therefore, we use the stable reference in history.location rather than useLocation.  This
      // guarantees the URL pathname is fresh.
      history.replace({
        pathname: history.location.pathname,
        search: queryString,
        state: history.location.state,
      });
    }
  }, [history, history.location, completeSessionsOverride]);

  return {
    completeSessionsOverride,
    setCompleteSessionsOverride,
  };
};
